<ion-refresher
  mode="ios"
  slot="fixed"
  [pullFactor]="0.5"
  [pullMin]="100"
  [pullMax]="200"
  (ionRefresh)="startRefresh($event)"
>
  <ion-refresher-content
    pullingIcon="chevron-down-circle-outline"
    pullingText=""
  >
  </ion-refresher-content>
</ion-refresher>
